import declareContext from './declareContext';
import { getReturnToUrl, getValidQueryParamsString } from 'src/dataLayer/localData/queryParams';

const extractProps = ({ locale, environment, queryParams }) => {
  const validQueryParamsString = getValidQueryParamsString(queryParams);
  // for backwards compatibility before we replace all uses of query-string with URLSearchParams
  // expose both the queryParams (string) and the queryParamsObj
  return {
    queryParams: validQueryParamsString,
    queryParamsObj: new URLSearchParams(validQueryParamsString),
    redirectTo: getReturnToUrl(queryParams),
    locale,
    environment
  };
};

const RouteParamsContext = declareContext(extractProps);

export const useRouteParamsContext = RouteParamsContext.useContext;
export const RouteParamsProvider = RouteParamsContext.Provider;
